<template>
  <span>{{ $fileSize(value) }}</span>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';
import FileUtilsMixin from 'vue-core/mixins/FileUtilsMixin';

export default {
  mixins: [ BaseColumnRendererMixin, FileUtilsMixin ]
};
</script>
